import { createFileRoute } from '@tanstack/react-router'
import { TaskDetailPage } from '../../../components/AdminTasks/TaskDetail'

export const Route = createFileRoute('/admin/tasks/$id')({
  component: AdminTaskDetailRoute,
})

function AdminTaskDetailRoute() {
  const { id } = Route.useParams()
  return <TaskDetailPage id={id} />
}
